import classNames from 'classnames'
import styles from './styles.module.less'

interface InfoCardProps {
  title: any
  action?: any
  children?: any
  className?: string
}
export const InfoCard = (props: InfoCardProps) => {
  const {title, action, children, className} = props
  return <div className={classNames(styles.cardContainer, !children && styles.noBottomBorder, className)}>
    <div className={classNames("flex-space-btw", styles.cardHeader)}>
      <div>{title}</div>
      {action && <div>{action}</div>}
    </div>
    {children && <div className={styles.cardContent}>{children}</div>}
  </div>
}